<template>
  <div>
    <div class="c-header c-bg">
      <div class="user">
        <img :src="user.avatar" />
        <div class="user-info">
          <h3>
            {{ user.name }}
            <van-icon name="bianji1" @click="editBasicInfo"></van-icon>
          </h3>
          <p>
            {{ user.sex }}士 <span>|</span> {{ user.age }}岁 <span>|</span>
            {{ user.workYear }}年工作经验 <span>|</span>{{ user.eduLevel }}
          </p>
        </div>
      </div>
      <ul class="links">
        <li>
          <van-icon name="shouji"></van-icon><span>{{ personal.mobile }}</span>
        </li>
        <li v-if="personal.email">
          <van-icon name="youxiang"></van-icon><span>{{ personal.email }}</span>
        </li>
      </ul>
    </div>
    <ul class="resume">
      <li>
        <div class="resume-header">
          <h3>求职意向</h3>
          <van-icon name="bianji1" @click="editIntention"></van-icon>
        </div>
        <div class="resume-body">
          <div class="job-wanted">
            <div class="wanted-header">
              <h4>求职状态：</h4>
              <span>{{ user.jobStatusName }}</span>
            </div>
            <ul
              class="wanted-list"
              v-for="item in user.wdJobWorkIntentionList"
              :key="item.id"
            >
              <li>
                <van-icon name="zhiyeweisheng1"></van-icon>
                <div class="w-detail">
                  <h5>{{ item.positionCategoryName }}</h5>
                  <span
                    >{{ item.salaryExpect | mapName(that, "salaryMap") }} ·
                    {{ item.areaName }} · {{ item.tradesName }} ·
                    {{ item.workType | mapName(that, "workType") }}</span
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li>
        <div class="resume-header">
          <h3>自我介绍</h3>
          <router-link
            :to="{
              name: 'editIntroduction',
              query: { id: personal.id, introduceSelf: personal.introduceSelf }
            }"
          >
            <van-icon name="bianji1"></van-icon>
          </router-link>
        </div>
        <div class="resume-body">
          <p class="about">
            {{ personal.introduceSelf }}
            <!-- 本人诚实守信，乐观开朗，沟通潜力强，肯学习，学习和动手潜力强，吃苦耐劳，用心向上，稳重踏实，职责心强，有主见，组织管理潜力好，团体意识强，能协助他人并自己独立… -->
          </p>
        </div>
      </li>
      <li>
        <div class="resume-header">
          <h3>工作经历</h3>
          <router-link :to="{ name: 'workHistory' }">
            <van-icon name="tianjia"></van-icon>
          </router-link>
        </div>
        <div class="resume-body">
          <div
            class="history-list"
            v-for="item in user.wdJobWorkExpList"
            :key="item.id"
          >
            <div class="hist-header">
              <h4>
                <van-icon name="gongsi"></van-icon>
                {{ item.unitName }}
              </h4>
              <router-link
                :to="{ name: 'workHistory', query: { id: item.id } }"
              >
                <van-icon name="bianji1"></van-icon>
              </router-link>
            </div>
            <div class="time">
              {{ item.workStartTime | formatDate }}
              <template v-if="item.workStartTime && item.workEndTime">
                - </template
              >{{ item.workEndTime | formatDate }}
            </div>
            <div class="h-name">
              <span>{{ item.jobName }}</span>
              <span>{{ item.salary | mapName(that, "salaryMap") }}</span>
            </div>
            <ul class="label">
              <li>{{ item.tradesName }}</li>
            </ul>
            <p>{{ item.workDescription }}</p>
          </div>
        </div>
      </li>
      <li>
        <div class="resume-header">
          <h3>教育经历</h3>
          <router-link :to="{ name: 'education' }">
            <van-icon name="tianjia"></van-icon>
          </router-link>
        </div>
        <div class="resume-body">
          <div
            class="history-list"
            v-for="item in user.wdJobEducationList"
            :key="item.id"
          >
            <div class="hist-header">
              <h4><van-icon name="shu"></van-icon>{{ item.schoolName }}</h4>
              <van-icon name="bianji1" @click="education(item.id)"></van-icon>
            </div>
            <div class="time">
              {{ item.studyStartTime | formatDate }}
              <template v-if="item.studyStartTime && item.studyEndTime">
                - </template
              >{{ item.studyEndTime | formatDate }}
            </div>
            <div class="h-name">
              <span
                >{{ item.edu | mapName(that, "eduType") }}
                {{ item.majorName }}</span
              >
            </div>
            <ul class="label">
              <li v-if="item.certificate">有学位证书</li>
            </ul>
          </div>
        </div>
      </li>
      <li>
        <div class="resume-header">
          <h3>获得证书</h3>
          <router-link :to="{ name: 'certificate' }">
            <van-icon name="tianjia"></van-icon>
          </router-link>
        </div>
        <div class="resume-body">
          <div
            class="history-list"
            v-for="item in user.wdJobCertificateList"
            :key="item.id"
          >
            <div class="hist-header">
              <h4><van-icon name="zhengshu"></van-icon>{{ item.certName }}</h4>
              <van-icon name="bianji1" @click="certificate(item.id)"></van-icon>
            </div>
            <div class="time">{{ item.certGetTime | formatDate }}</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "myResume",
  data() {
    return {
      that: this,
      user: {},
      personal: {},
      work: {},
      educate: {}
    };
  },
  filters: {
    mapName(val, that, objKey) {
      for (let [key, value] of that.module[objKey].entries()) {
        value === val && (val = key);
      }
      return val;
    },
    formatDate(val) {
      return moment(val).format("YYYY-MM-DD");
    }
  },
  methods: {
    moment,
    onload() {
      this.module.api.resumeInfo({
        params: {},
        success: res => {
          this.user = res;
        }
      });
      this.module.api.personalDetail({
        params: {},
        success: res => {
          this.personal = res;
        }
      });
    },
    editBasicInfo() {
      this.$router.push({
        name: "editBasicInfo",
        query: { id: this.personal.id }
      });
    },
    editIntention() {
      const { jobStatus, jobStatusName } = this.user;
      this.$router.push({
        name: "editIntention",
        query: { jobStatus, jobStatusName }
      });
    },
    editIntroduction() {
      this.$router.push({
        name: "editIntroduction",
        query: { user: this.user }
      });
    },
    education(id) {
      this.$router.push({
        name: "education",
        query: { id, eduLength: this.user.wdJobEducationList.length }
      });
    },
    certificate(id) {
      this.$router.push({ name: "certificate", query: { id } });
    }
  },
  mounted() {
    this.onload();
  }
};
</script>

<style lang="less" scoped>
.c-header .user .user-info h3 {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  i {
    font-size: 16px;
    margin-left: 14px;
  }
}
.c-header .user img {
  width: 88px;
  height: 88px;
  object-fit: cover;
}
.user {
  flex-direction: row-reverse;
  margin-left: 0;
  margin-right: 20px;
}
.c-header .user .user-info:after {
  display: none;
}
.links {
  margin: 20px;
  li {
    color: #fff;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 6px;
    }
    i {
      width: 30px;
    }
  }
}
.w-detail h5 {
  margin-bottom: 5px;
  font-weight: bold;
}
</style>
